import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { DateTime } from 'scaleflow/utils/date-time';
import { objectAppend } from 'scaleflow/utils/obj-append';

export default class RoadmapListTableIndexComponent extends Component {
  @service intl;

  @tracked showDeleteModal = false;

  @tracked selectedRoadmap = null;

  get columns() {
    if (this.args?.columns) return this.args?.columns;
    return [
      {
        name: this.intl.t('roadmap.table.title'),
        valuePath: 'title',
        key: 'title',
        isSortable: false,
      },
      {
        name: this.intl.t('roadmap.start-date'),
        valuePath: 'start_date',
        key: 'start_Date',
        class: '!w-[15%]',
        cellClass: '!justify-start',
        isSortable: false,
      },
      {
        name: this.intl.t('roadmap.end-date'),
        valuePath: 'end_date',
        key: 'end_date',
        class: '!w-[15%]',
        cellClass: '!justify-start',
        isSortable: false,
      },
      {
        name: '',
        valuePath: 'grid',
        class: '!w-[10%]',
        key: 'grid',
        component: 'link',
        type: 'primary',
        test_id: 'grid-roadmap',
      },
      {
        name: '',
        valuePath: 'lanes',
        class: '!w-[10%]',
        key: 'lanes',
        component: 'link',
        type: 'primary',
        test_id: 'lanes-roadmap',
      },
      {
        name: '',
        valuePath: 'timeline',
        class: '!w-[10%]',
        key: 'timeline',
        component: 'link',
        type: 'primary',
        test_id: 'timeline-roadmap',
        isSortable: false,
      },
      {
        name: '',
        valuePath: 'edit',
        class: '!w-[10%]',
        key: 'edit',
        component: 'link',
        type: 'primary',
        test_id: 'edit-roadmap',
        isSortable: false,
      },
      {
        name: '',
        valuePath: 'delete',
        class: '!w-[10%]',
        key: 'delete',
        component: 'button',
        type: 'danger',
        test_id: 'delete',
        isSortable: false,
      },
    ];
  }

  @action
  unselectRoadmap() {
    this.selectedRoadmap = null;
  }

  @action
  handleDeleteRoadmap(item) {
    this.selectedRoadmap = item;
    this.toggleDeleteModal(true);
  }

  @action
  toggleDeleteModal(flag) {
    if (flag === undefined) this.showDeleteModal = !this.showDeleteModal;
    else this.showDeleteModal = flag;
  }

  @action
  deleteRoadmap() {
    this.selectedRoadmap?.destroyRecord?.();
    this.unselectRoadmap();
  }

  @action
  handleDismissDeleteModal() {
    this.unselectRoadmap();
    this.toggleDeleteModal(false);
  }

  get rows() {
    if (this.args?.rows) return this.args?.rows;
    const roadmapList = this.args?.list.map((item) =>
      objectAppend(
        {
          title: item.title,
          start_date: DateTime.from(item.start_date).format('DD MMM, YYYY'),
          end_date: DateTime.from(item.end_date).format('DD MMM, YYYY'),
          grid: {
            label: this.intl.t('pages.grid'),
            route: 'roadmap.strategy.roadmap.grid',
          },
          edit: {
            label: this.intl.t('roadmap.edit'),
            route: 'roadmap.strategy.roadmap.edit',
          },
          lanes: {
            label: this.intl.t('pages.lanes'),
            route: 'roadmap.strategy.roadmap.lanes',
          },
          timeline: {
            label: this.intl.t('dictionary.timeline'),
            route: 'roadmap.strategy.roadmap.timeline',
          },
          delete: {
            label: this.intl.t('roadmap.delete'),
            onClick: () => this.handleDeleteRoadmap(item),
          },
        },
        { model: item },
      ),
    );
    return roadmapList;
  }
}
